import * as React from "react";

export const useClickOutside = (handler: () => void) => {
    const targetRef = React.useRef<any>(null);

    const handleClickOutside = (event: Event) => {
        if(document.activeElement === document.querySelector("iframe"))
            handler();
        if(targetRef?.current && event.target instanceof Node && !targetRef.current.contains(event.target))
            handler();
    };

    React.useEffect(() => {
        window.addEventListener('blur', handleClickOutside);
        document.addEventListener('click', handleClickOutside);

        return () => {
            window.removeEventListener('blur', handleClickOutside);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [targetRef.current, handler]);

    return { targetRef };
};